var _a;
import { __assign, __awaiter, __extends, __generator, __spreadArrays } from "tslib";
import * as React from 'react';
import { translate } from 'react-i18next';
import ChevronDownSmall from 'wix-ui-icons-common/ChevronDownSmall';
import { isEmailValid } from '../../../utils/misc.utils';
import { AllowedAdditionalEmailStatuses } from '../../../config';
import { Input, DropdownBase, TextButton, Layout, Cell, Tooltip, } from 'wix-style-react';
import { ValidationErrorTypes } from '../../../utils/FieldList.utils';
export var EmailStatusOptions;
(function (EmailStatusOptions) {
    EmailStatusOptions["notSet"] = "transactional";
    EmailStatusOptions["subscribed"] = "recurring";
    EmailStatusOptions["unSubscribed"] = "optOut";
})(EmailStatusOptions || (EmailStatusOptions = {}));
export var EmailStatusAdditionalOptions;
(function (EmailStatusAdditionalOptions) {
    EmailStatusAdditionalOptions["pendingSubscription"] = "pendingSubscription";
})(EmailStatusAdditionalOptions || (EmailStatusAdditionalOptions = {}));
export var emailSubscriptionOptions = [
    {
        id: EmailStatusOptions.notSet,
        key: EmailStatusOptions.notSet,
        value: "editContact.field.email.subscriptionType." + EmailStatusOptions.notSet,
    },
    {
        id: EmailStatusOptions.subscribed,
        key: EmailStatusOptions.subscribed,
        value: "editContact.field.email.subscriptionType." + EmailStatusOptions.subscribed,
    },
    {
        id: EmailStatusOptions.unSubscribed,
        key: EmailStatusOptions.unSubscribed,
        value: "editContact.field.email.subscriptionType." + EmailStatusOptions.unSubscribed,
    },
];
var EmailStatuses = (_a = {},
    _a[ValidationErrorTypes.INVALID_EMAIL] = {
        status: Input.StatusError,
        statusMessage: 'editContact.field.email.errors.invalid',
    },
    _a[ValidationErrorTypes.EMPTY_REQUIRED_FIELD] = {
        status: Input.StatusError,
        statusMessage: 'editContact.field.email.errors.required',
    },
    _a[ValidationErrorTypes.DUPLICATE_EMAIL] = {
        status: Input.StatusWarning,
        statusMessage: 'editContact.field.email.errors.duplicate',
    },
    _a);
var EmailInputComponent = /** @class */ (function (_super) {
    __extends(EmailInputComponent, _super);
    function EmailInputComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.convertAdditionalStatusToOption = function (status) { return ({
            id: status,
            key: status,
            value: "editContact.field.email.subscriptionType." + status,
        }); };
        _this.renderSubscriptionDropdown = function () {
            var value = _this.props.value;
            var showCustomOptions = Object.values(AllowedAdditionalEmailStatuses).includes(value.originalEmailStatus);
            var options = __spreadArrays(emailSubscriptionOptions);
            if (showCustomOptions) {
                options.push(_this.convertAdditionalStatusToOption(value.originalEmailStatus));
            }
            return (React.createElement(DropdownBase, { dataHook: "email-subscription-dropdown", options: _this.translateSubscriptionOptions(options), onSelect: function (SubStatus) {
                    return _this.props.onValueChange({
                        emailStatus: SubStatus.id,
                    });
                }, selectedId: _this.props.value.emailStatus }, _this.renderDropdownTrigger));
        };
        _this.translateSubscriptionOptions = function (options) {
            return options.map(function (option) {
                var translatedOption = __assign(__assign({}, option), { value: _this.props.t(option.value), dataHook: option.key });
                return translatedOption;
            });
        };
        _this.renderDropdownTrigger = function (_a) {
            var toggle = _a.toggle, selectedOption = _a.selectedOption;
            return (React.createElement(TextButton, { dataHook: "email-subscription-select", size: "tiny", suffixIcon: React.createElement(ChevronDownSmall, null), onClick: toggle }, (selectedOption && selectedOption.value) ||
                _this.props.t('editContact.field.email.subscriptionType.transactional')));
        };
        _this.onBlur = function () { return __awaiter(_this, void 0, void 0, function () {
            var email, onCheckForDuplicateEmail, isValid, isDuplicateEmail;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        email = this.props.value.email;
                        onCheckForDuplicateEmail = this.props.onCheckForDuplicateEmail;
                        if (!email) {
                            return [2 /*return*/, this.setState({ inputStatus: null })];
                        }
                        isValid = isEmailValid(email);
                        if (!isValid) {
                            return [2 /*return*/, this.setState({
                                    inputStatus: isValid ? null : EmailStatuses.INVALID_EMAIL,
                                })];
                        }
                        return [4 /*yield*/, onCheckForDuplicateEmail(email)];
                    case 1:
                        isDuplicateEmail = _a.sent();
                        if (isDuplicateEmail) {
                            return [2 /*return*/, this.setState({
                                    inputStatus: EmailStatuses.DUPLICATE_EMAIL,
                                })];
                        }
                        this.setState({ inputStatus: null });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            inputStatus: _this.props.errorType
                ? EmailStatuses[_this.props.errorType]
                : props.value.email && !isEmailValid(props.value.email)
                    ? EmailStatuses[ValidationErrorTypes.INVALID_EMAIL]
                    : null,
        };
        return _this;
    }
    EmailInputComponent.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.errorType && this.props.errorType !== prevProps.errorType) {
            this.setState({
                inputStatus: EmailStatuses[this.props.errorType],
            });
        }
        else if (prevProps.errorType && !this.props.errorType) {
            this.setState({
                inputStatus: null,
            });
        }
    };
    EmailInputComponent.prototype.render = function () {
        var _this = this;
        var t = this.props.t;
        return (React.createElement(Layout, { gap: 0 },
            React.createElement(Cell, { span: 12 },
                React.createElement(Tooltip, { dataHook: "login-email-tooltip", content: t('editContact.field.email.tooltip.loginEmail'), disabled: !this.props.value.isLoginEmail },
                    React.createElement("span", null,
                        React.createElement(Input, { className: this.state.inputStatus && 'ec-error-field', dataHook: "email-input", placeholder: t('editContact.field.email.tags.default'), onChange: function (e) {
                                return _this.props.onValueChange({ email: e.currentTarget.value });
                            }, value: this.props.value.email, onBlur: this.onBlur, status: (this.state.inputStatus && this.state.inputStatus.status) ||
                                null, statusMessage: this.state.inputStatus &&
                                t(this.state.inputStatus.statusMessage), readOnly: this.props.value.isLoginEmail }))),
                this.renderSubscriptionDropdown())));
    };
    return EmailInputComponent;
}(React.PureComponent));
export default translate()(EmailInputComponent);
//# sourceMappingURL=EmailInput.js.map